import { Component, OnInit } from '@angular/core';
import { AlertifyService } from '../services/alertify.service';
import { ApiauthService } from '../services/apiauth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  logueado = false;
  usrData: any;

  constructor(
    public apiAuth: ApiauthService,
    private alertify: AlertifyService
  ) {
    var usr = this.apiAuth.usuarioData;
    if (usr) {
      if (usr.logueado) {
        this.logueado = true;
        this.usrData = usr;
      }
    }
  }

  ngOnInit(): void {}

  pruebaLogueado() {
    if (this.apiAuth.loggedIn()) {
      this.alertify.message('pruebaLogueado mess');
      this.alertify.success('pruebaLogueado suss');
      this.alertify.warning('pruebaLogueado war');
      this.alertify.error('pruebaLogueado err');
    } else {
      //ingresa si el token ya expiro
      this.apiAuth.logout();
      //aqui mando a redireccion
    }
  }
}
